import {Injectable} from '@angular/core';

@Injectable()
export class ProjectsBodyScrollingService {

    public disableBodyScrolling() {
        document.body.classList.add('projects-scrolling-disabled');
    }

    public enableBodyScrolling() {
        document.body.classList.remove('projects-scrolling-disabled');
    }
}
